export default "/images/walking-dead-shooter.png";